// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component } from '@angular/core';

@Component({
    templateUrl: 'page-not-found.component.html'
})
export class PageNotFoundComponent { }

